interface ScrollIntoContainerOptions {
  behavior?: ScrollBehavior;
}

/**
 * Scroll a child element into view within a single scrollable container,
 * without affecting any ancestor scroll positions.
 */
export function scrollIntoContainer(
  container: HTMLElement,
  child: HTMLElement,
  options?: ScrollIntoContainerOptions,
): void {
  const containerRect = container.getBoundingClientRect();
  const childRect = child.getBoundingClientRect();
  const scrollLeft = container.scrollLeft;
  const childLeft = childRect.left - containerRect.left + scrollLeft;
  const childRight = childLeft + childRect.width;
  const visibleRight = scrollLeft + container.clientWidth;

  let left: number | undefined;
  if (childLeft < scrollLeft) {
    left = childLeft;
  } else if (childRight > visibleRight) {
    left = childRight - container.clientWidth;
  }

  if (left !== undefined) {
    container.scrollTo({ left, behavior: options?.behavior });
  }
}
